
import { defineComponent, computed } from 'vue'
import { useDailyReport } from '@/composable/useDailyReport'
import QTable from 'quasar/src/components/table/QTable.js';
import { useProfile } from '@/composable/useProfile'

export default defineComponent({
  name: 'DailyReportSummaryTable',

  setup() {
    const { isPrintMode, data } = useDailyReport()
    const { currentProject } = useProfile()
    // const colStyle = 'white-space: pre-wrap'
    const columns = [
      {
        align: 'left',
        name: 'punctualityShuttle',
        label: 'Punktlighet pendel RT +3',
        field: 'punctualityShuttle',
      },
      {
        align: 'left',
        name: 'punctualityRegion',
        label: 'Punktlighet region RT +5',
        field: 'punctualityRegion',
      },

      {
        align: 'left',
        name: 'deviatingCrew',
        label: 'Avvikande bemanning',
        field: 'deviatingCrew',
        style: '',
      },

      {
        align: 'left',
        name: 'deviations',
        label: 'Avvikande fordon',
        field: 'deviations',
        style: '',
      },

      {
        align: 'left',
        name: 'withdrawn',
        label: 'Inställda tåg (Inkl. delinställda)',
        field: 'withdrawn',
        style: '',
      },
    ].filter((x) =>
      currentProject.value?.description === 'SJ Krösatåg'
        ? x.name !== 'deviations' && x.name !== 'punctualityShuttle'
        : true
    )

    const rows = computed(() => {
      return [
        {
          punctualityShuttle: data.value.summary.rows
            .find((x) => x.label === 'Punktlighet')
            ?.data.find((t) => t.name === 'Pendel totalt')?.percentage,
          punctualityRegion: data.value.summary.rows
            .find((x) => x.label === 'Punktlighet')
            ?.data.find((t) => t.name === 'Region totalt')?.percentage,
          deviatingCrew: data.value.summary.rows
            .find((x) => x.label === 'Bemanningsavvikelser')
            ?.data.find((t) => t.name === 'All tågtrafik')?.count,
          deviations: data.value.summary.rows
            .find((x) => x.label === 'Fordonsavvikelser')
            ?.data.find((t) => t.name === 'All tågtrafik')?.count,
          withdrawn: data.value.summary.rows
            .find((x) => x.label === 'Operativ regularitet')
            ?.data.find((t) => t.name === 'All tågtrafik')?.count,
        },
      ]
    })

    return { rows, columns, isPrintMode, currentProject }
  },
})
